import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] w-full flex flex-col items-center justify-center gap-4 py-24 px-6 text-center" data-testid="not-found">
      <Compass className="h-10 w-10 text-muted-foreground/50" strokeWidth={1.5} />
      <h1 className="font-display text-2xl font-semibold">Page not found</h1>
      <p className="text-sm text-muted-foreground">That page doesn't exist or has moved.</p>
      <Link to="/app"><Button className="rounded-md bg-amber-500 text-black hover:bg-amber-400" data-testid="not-found-home">Go to the app</Button></Link>
    </div>
  );
}
